/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        pagination: {
            table: {
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                paddingHorizontal: {
                    value: "32px",
                    type: "dimension",
                },
                paddingVertical: {
                    value: "16px",
                    type: "dimension",
                },
                status: {
                    disabled: {
                        color: {
                            value: "#b3b3b3",
                            type: "color",
                        },
                    },
                },
                rowPerPage: {
                    title: {
                        gap: {
                            value: "12px",
                            type: "dimension",
                        },
                    },
                    icon: {
                        gap: {
                            value: "40px",
                            type: "dimension",
                        },
                    },
                },
                displayRow: {
                    icon: {
                        gap: {
                            value: "40px",
                            type: "dimension",
                        },
                    },
                },
            },
            standalone: {
                paddingHorizontal: {
                    value: "8px",
                    type: "dimension",
                },
                paddingVertical: {
                    value: "16px",
                    type: "dimension",
                },
                gap: {
                    value: "0",
                    type: "dimension",
                },
                scrollButton: {
                    color: {
                        value: "#455D82",
                        type: "color",
                    },
                },
                button: {
                    borderRadius: {
                        value: "2px",
                        type: "dimension",
                    },
                    height: {
                        value: "31px",
                        type: "dimension",
                    },
                    width: {
                        value: "32px",
                        type: "dimension",
                    },
                    fontSize: {
                        value: "1rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 600,
                        type: "fontWeight",
                    },
                    inactive: {
                        default: {
                            backgroundColor: {
                                value: "#94949400",
                                type: "color",
                            },
                            color: {
                                value: "#455D82",
                                type: "color",
                            },
                        },
                        hover: {
                            backgroundColor: {
                                value: "#94949429",
                                type: "color",
                            },
                            color: {
                                value: "#364262",
                                type: "color",
                            },
                        },
                        active: {
                            backgroundColor: {
                                value: "#94949452",
                                type: "color",
                            },
                            color: {
                                value: "#252C44",
                                type: "color",
                            },
                        },
                        disabled: {
                            backgroundColor: {
                                value: "#94949400",
                                type: "color",
                            },
                            color: {
                                value: "#b3b3b3",
                                type: "color",
                            },
                        },
                    },
                    active: {
                        default: {
                            backgroundColor: {
                                value: "#455D82",
                                type: "color",
                            },
                            color: {
                                value: "#ffffff",
                                type: "color",
                            },
                        },
                        hover: {
                            backgroundColor: {
                                value: "#364262",
                                type: "color",
                            },
                        },
                        active: {
                            backgroundColor: {
                                value: "#252C44",
                                type: "color",
                            },
                        },
                        disabled: {
                            backgroundColor: {
                                value: "#e6e6e6",
                                type: "color",
                            },
                            color: {
                                value: "#b3b3b3",
                                type: "color",
                            },
                        },
                    },
                },
            },
        },
    },
};
export default tokens;
